module.exports = __webpack_public_path__ + "img/step-2.582fde82.svg";